import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/RoomsPreview.css';

const RoomsPreview = () => {
  const navigate = useNavigate();

  const rooms = [
    {
      id: 1,
      name: 'Non-AC Room',
      price: '₹1,200',
      shortStayPrice: '₹799',
      pricePer: 'per night',
      shortStayLabel: '4 Hrs - ₹799',
      image: 'https://images.unsplash.com/photo-1631049307264-da0ec9d70304?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      amenities: ['TV', 'WiFi', 'Attached Bathroom', 'Ceiling Fan', 'Couple Friendly'],
      size: '220 sq ft',
      beds: '1 Double Bed',
      description: 'Comfortable and budget-friendly room with all essential amenities',
      badge: '💲 Best Value',
      roomType: 'Non-AC'
    },
    {
      id: 2,
      name: 'AC Room',
      price: '₹1,800',
      shortStayPrice: '₹1,099',
      pricePer: 'per night',
      shortStayLabel: '4 Hrs - ₹1,099',
      image: 'https://images.unsplash.com/photo-1618773928121-c32242e63f39?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      amenities: ['AC', 'TV', 'WiFi', 'Attached Bathroom', 'Mini Fridge', 'Couple Friendly'],
      size: '280 sq ft',
      beds: '1 King Bed',
      description: 'Air-conditioned room with modern amenities for a comfortable stay',
      badge: '⭐ Most Popular',
      roomType: 'AC'
    },
    {
      id: 3,
      name: 'Deluxe AC Room',
      price: '₹2,800',
      shortStayPrice: '₹1,699',
      pricePer: 'per night',
      shortStayLabel: '4 Hrs - ₹1,699',
      image: 'https://images.unsplash.com/photo-1582719478250-c89cae4dc85b?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80',
      amenities: ['AC', 'TV', 'WiFi', 'Mini Bar', 'Living Area', 'Couple Friendly'],
      size: '400 sq ft',
      beds: '1 King Bed + Sofa',
      description: 'Spacious AC room with premium amenities for a luxurious experience',
      badge: '⭐ Couple Friendly',
      roomType: 'AC Deluxe'
    }
  ];

  // Handle phone call
  const handleCall = () => {
    window.location.href = 'tel:+918019472678';
  };

  // Handle WhatsApp chat
  const handleWhatsApp = () => {
    const phoneNumber = '918019472678'; // Without + for WhatsApp
    const message = 'Hi, I would like to enquire about room availability at AA GRAND HOTEL.';
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
  };

  // Handle navigation to rooms page
  const handleViewAllRooms = () => {
    navigate('/rooms');
  };

  return (
    <section className="rpv-rooms-preview-section" id="rooms">
      <div className="rpv-rooms-preview-container">
        {/* Section Header */}
        <div className="rpv-rooms-preview-header">
          <span className="rpv-rooms-preview-badge">✦ Our Rooms</span>
          <h2 className="rpv-rooms-preview-title">
            Luxurious <span className="rpv-highlight">Accommodations</span>
          </h2>
          <p className="rpv-rooms-preview-subtitle">
            Experience comfort and elegance in our well-appointed rooms
          </p>
        </div>

        {/* Special Offers Banner */}
        <div className="rpv-rooms-offer-banner">
          <div className="rpv-offer-content">
            <span className="rpv-offer-icon">💕</span>
            <div className="rpv-offer-text">
              <h4>Couple Friendly • Short Stays Available</h4>
              <p>Enjoy 4-hour stays at special rates | 100% Privacy Guaranteed</p>
            </div>
          </div>
          <div className="rpv-offer-tag">
            <span>🔥 Best Deal</span>
          </div>
        </div>

        {/* Rooms Grid */}
        <div className="rpv-rooms-preview-grid">
          {rooms.map((room) => (
            <div className="rpv-room-card" key={room.id}>
              <div className="rpv-room-card-image">
                <img src={room.image} alt={room.name} />
                <div className="rpv-room-price-tag">
                  <span className="rpv-price">{room.price}</span>
                  <span className="rpv-price-per">{room.pricePer}</span>
                  <span className="rpv-price-short">{room.shortStayLabel}</span>
                </div>
                <div className="rpv-room-badge" style={{
                  background: room.roomType === 'Non-AC' 
                    ? 'linear-gradient(135deg, #4a90d9, #357abd)' 
                    : room.roomType === 'AC' 
                    ? 'linear-gradient(135deg, #FFD700, #FFA500)'
                    : 'linear-gradient(135deg, #FF6B6B, #ee5a24)',
                  color: room.roomType === 'Non-AC' ? '#ffffff' : '#1a0a0a'
                }}>
                  <span>{room.badge}</span>
                </div>
              </div>
              
              <div className="rpv-room-card-content">
                <div className="rpv-room-type-badge">
                  <span className={`rpv-room-type-tag ${room.roomType === 'Non-AC' ? 'rpv-non-ac' : 'rpv-ac'}`}>
                    {room.roomType}
                  </span>
                </div>
                <h3 className="rpv-room-name">{room.name}</h3>
                <p className="rpv-room-description">{room.description}</p>
                
                <div className="rpv-room-specs">
                  <div className="rpv-spec-item">
                    <span className="rpv-spec-icon">📐</span>
                    <span>{room.size}</span>
                  </div>
                  <div className="rpv-spec-item">
                    <span className="rpv-spec-icon">🛏️</span>
                    <span>{room.beds}</span>
                  </div>
                  <div className="rpv-spec-item">
                    <span className="rpv-spec-icon">💕</span>
                    <span>Couple Friendly</span>
                  </div>
                </div>

                <div className="rpv-room-amenities">
                  {room.amenities.map((amenity, index) => (
                    <span key={index} className="rpv-amenity-tag">
                      ✓ {amenity}
                    </span>
                  ))}
                </div>

                <div className="rpv-room-card-actions">
                  <button onClick={handleCall} className="rpv-room-btn-primary">
                    📞 Book Now
                  </button>
                  <button onClick={handleWhatsApp} className="rpv-room-btn-secondary">
                     Enquire Now →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Short Stay CTA */}
        <div className="rpv-short-stay-cta">
          <div className="rpv-short-stay-content">
            <span className="rpv-short-stay-icon">⏰</span>
            <div>
              <h3>Need a Quick Stay?</h3>
              <p>Book our 4-hour short stay packages at special rates. Perfect for:</p>
              <div className="rpv-short-stay-features">
                <span>💕 Couple Getaways</span>
                <span>🛏️ Day Use Rooms</span>
                <span>✈️ Transit Stays</span>
                <span>💼 Business Meetings</span>
              </div>
            </div>
          </div>
          <button onClick={handleCall} className="rpv-short-stay-btn">
            📞 Call for Short Stay Booking
          </button>
        </div>

        {/* View All Button */}
        <div className="rpv-rooms-preview-footer">
          <button onClick={handleViewAllRooms} className="rpv-view-all-btn">
            View All Rooms →
          </button>
        </div>
      </div>
    </section>
  );
};

export default RoomsPreview;